import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { Tabs } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { useParamState } from '@app/util/hooks/useParamState'
import {
  topicCommunityTabs,
  topicCommunityTabsQueryParamName,
} from './constants'
import { Thread } from '@app/components/blocks/thread/Thread'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { TopicCommunityPageOverview } from './sections/Overview'
import { TopicCommunityPageInitiatives } from './sections/Initiatives'
import { TopicCommunityPageKnowledgeHub } from './sections/KnowledgeHub'
import { TopicCommunityPageContact } from './sections/Contact'

export const TabContent = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app.topicCommunityPage.tabs

  const [tab, setTab] = useParamState(
    topicCommunityTabs,
    topicCommunityTabs.overview,
    topicCommunityTabsQueryParamName,
  )

  return (
    <Column alignItems="stretch" gap="2rem" style={{ width: '100%' }}>
      <Tabs.Group selectedTab={tab}>
        <Tabs.Tab
          label={t.overview}
          tabKey={topicCommunityTabs.overview}
          onSelectTab={setTab}
        />
        <Tabs.Tab
          label={t.thread}
          tabKey={topicCommunityTabs.thread}
          onSelectTab={setTab}
        />
        <Tabs.Tab
          label={t.initiatives}
          tabKey={topicCommunityTabs.initiatives}
          onSelectTab={setTab}
        />
        <Tabs.Tab
          label={t.knowledgeHub}
          tabKey={topicCommunityTabs.knowledgeHub}
          onSelectTab={setTab}
        />
        <Tabs.Tab
          label={t.contactInfo}
          tabKey={topicCommunityTabs.contactInfo}
          onSelectTab={setTab}
        />
      </Tabs.Group>

      {match(tab)
        .with(topicCommunityTabs.overview, () => (
          <TopicCommunityPageOverview topicCommunity={topicCommunity} />
        ))
        .with(topicCommunityTabs.thread, () =>
          topicCommunity.thread ? (
            <Thread key="thread" threadId={topicCommunity.thread.id} />
          ) : null,
        )
        .with(topicCommunityTabs.initiatives, () => (
          <TopicCommunityPageInitiatives topicCommunity={topicCommunity} />
        ))
        .with(topicCommunityTabs.knowledgeHub, () => (
          <TopicCommunityPageKnowledgeHub topicCommunity={topicCommunity} />
        ))
        .with(topicCommunityTabs.contactInfo, () => (
          <TopicCommunityPageContact topicCommunity={topicCommunity} />
        ))
        .exhaustive()}
    </Column>
  )
}
